import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8c16beae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "slide-design-panel" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "背景填充", -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("纯色填充")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("图片填充")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("渐变填充")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"1"} }, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode("缩放")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("拼贴")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("缩放铺满")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("线性渐变")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("径向渐变")
const _hoisted_13 = {
  key: 0,
  class: "background-image-wrapper"
}
const _hoisted_14 = { class: "background-image" }
const _hoisted_15 = {
  key: 1,
  class: "background-gradient-wrapper"
}
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "起点颜色：", -1))
const _hoisted_18 = { class: "row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "终点颜色：", -1))
const _hoisted_20 = {
  key: 0,
  class: "row"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "渐变角度：", -1))
const _hoisted_22 = { class: "row" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("应用背景到全部")
const _hoisted_24 = { class: "row" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "画布尺寸：", -1))
const _hoisted_26 = /*#__PURE__*/_createTextVNode("宽屏 16 : 9")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("宽屏 16 ：10")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("标准 4 ：3")
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "全局主题", -1))
const _hoisted_30 = { class: "row" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "字体：", -1))
const _hoisted_32 = { class: "row" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "字体颜色：", -1))
const _hoisted_34 = { class: "row" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "背景颜色：", -1))
const _hoisted_36 = { class: "row" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "主题色：", -1))
const _hoisted_38 = { class: "row" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode("应用主题到全部")
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "预置主题", -1))
const _hoisted_41 = { class: "theme-list" }
const _hoisted_42 = { class: "theme-item-content" }
const _hoisted_43 = { class: "colors" }
const _hoisted_44 = { class: "btns" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]

import { computed, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import { SlideBackground, SlideTheme } from '@/types/slides'
import { PRESET_THEMES } from '@/configs/theme'
import { WEB_FONTS } from '@/configs/font'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'
import useSlideTheme from '@/hooks/useSlideTheme'

import ColorButton from './common/ColorButton.vue'
import { getImageDataURL } from '@/utils/image'


export default /*#__PURE__*/_defineComponent({
  __name: 'SlideDesignPanel',
  setup(__props) {

const slidesStore = useSlidesStore()
const { availableFonts } = storeToRefs(useMainStore())
const { slides, currentSlide, viewportRatio, theme } = storeToRefs(slidesStore)

const background = computed(() => {
  if (!currentSlide.value.background) {
    return {
      type: 'solid',
      value: '#fff',
    } as SlideBackground
  }
  return currentSlide.value.background
})

const { addHistorySnapshot } = useHistorySnapshot()
const {
  applyPresetThemeToSingleSlide,
  applyPresetThemeToAllSlides,
  applyThemeToAllSlides,
} = useSlideTheme()

// 设置背景模式：纯色、图片、渐变色
const updateBackgroundType = (type: 'solid' | 'image' | 'gradient') => {
  if (type === 'solid') {
    const newBackground: SlideBackground = {
      ...background.value,
      type: 'solid',
      color: background.value.color || '#fff',
    }
    slidesStore.updateSlide({ background: newBackground })
  }
  else if (type === 'image') {
    const newBackground: SlideBackground = {
      ...background.value,
      type: 'image',
      image: background.value.image || '',
      imageSize: background.value.imageSize || 'cover',
    }
    slidesStore.updateSlide({ background: newBackground })
  }
  else {
    const newBackground: SlideBackground = {
      ...background.value,
      type: 'gradient',
      gradientType: background.value.gradientType || 'linear',
      gradientColor: background.value.gradientColor || ['#fff', '#fff'],
      gradientRotate: background.value.gradientRotate || 0,
    }
    slidesStore.updateSlide({ background: newBackground })
  }
  addHistorySnapshot()
}

// 设置背景图片
const updateBackground = (props: Partial<SlideBackground>) => {
  slidesStore.updateSlide({ background: { ...background.value, ...props } })
  addHistorySnapshot()
}

// 上传背景图片
const uploadBackgroundImage = (files: FileList) => {
  const imageFile = files[0]
  if (!imageFile) return
  getImageDataURL(imageFile).then(dataURL => updateBackground({ image: dataURL }))
}

// 应用当前页背景到全部页面
const applyBackgroundAllSlide = () => {
  const newSlides = slides.value.map(slide => {
    return {
      ...slide,
      background: currentSlide.value.background,
    }
  })
  slidesStore.setSlides(newSlides)
  addHistorySnapshot()
}

// 设置主题
const updateTheme = (themeProps: Partial<SlideTheme>) => {
  slidesStore.setTheme(themeProps)
}

// 设置画布尺寸（宽高比例）
const updateViewportRatio = (value: number) => {
  slidesStore.setViewportRatio(value)
}

return (_ctx: any,_cache: any) => {
  const _component_SelectOption = _resolveComponent("SelectOption")!
  const _component_Select = _resolveComponent("Select")!
  const _component_ColorPicker = _resolveComponent("ColorPicker")!
  const _component_Popover = _resolveComponent("Popover")!
  const _component_IconPlus = _resolveComponent("IconPlus")!
  const _component_FileInput = _resolveComponent("FileInput")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_SelectOptGroup = _resolveComponent("SelectOptGroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Select, {
        style: {"flex":"10"},
        value: _unref(background).type,
        onChange: _cache[0] || (_cache[0] = value => updateBackgroundType(value as 'gradient' | 'image' | 'solid'))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SelectOption, { value: "solid" }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_SelectOption, { value: "image" }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_SelectOption, { value: "gradient" }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"]),
      _hoisted_7,
      (_unref(background).type === 'solid')
        ? (_openBlock(), _createBlock(_component_Popover, {
            key: 0,
            trigger: "click"
          }, {
            content: _withCtx(() => [
              _createVNode(_component_ColorPicker, {
                modelValue: _unref(background).color,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = color => updateBackground({ color }))
              }, null, 8, ["modelValue"])
            ]),
            default: _withCtx(() => [
              _createVNode(ColorButton, {
                color: _unref(background).color || '#fff',
                style: {"flex":"10"}
              }, null, 8, ["color"])
            ]),
            _: 1
          }))
        : (_unref(background).type === 'image')
          ? (_openBlock(), _createBlock(_component_Select, {
              key: 1,
              style: {"flex":"10"},
              value: _unref(background).imageSize || 'cover',
              onChange: _cache[2] || (_cache[2] = value => updateBackground({ imageSize: value as 'repeat' | 'cover' | 'contain' }))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SelectOption, { value: "contain" }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }),
                _createVNode(_component_SelectOption, { value: "repeat" }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }),
                _createVNode(_component_SelectOption, { value: "cover" }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"]))
          : (_openBlock(), _createBlock(_component_Select, {
              key: 2,
              style: {"flex":"10"},
              value: _unref(background).gradientType,
              onChange: _cache[3] || (_cache[3] = value => updateBackground({ gradientType: value as 'linear' | 'radial' }))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SelectOption, { value: "linear" }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }),
                _createVNode(_component_SelectOption, { value: "radial" }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"]))
    ]),
    (_unref(background).type === 'image')
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(_component_FileInput, {
            onChange: _cache[4] || (_cache[4] = files => uploadBackgroundImage(files))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", {
                  class: "content",
                  style: _normalizeStyle({ backgroundImage: `url(${_unref(background).image})` })
                }, [
                  _createVNode(_component_IconPlus)
                ], 4)
              ])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_unref(background).type === 'gradient')
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode(_component_Popover, { trigger: "click" }, {
              content: _withCtx(() => [
                _createVNode(_component_ColorPicker, {
                  modelValue: _unref(background).gradientColor![0],
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = value => updateBackground({ gradientColor: [value, _unref(background).gradientColor![1]] }))
                }, null, 8, ["modelValue"])
              ]),
              default: _withCtx(() => [
                _createVNode(ColorButton, {
                  color: _unref(background).gradientColor![0],
                  style: {"flex":"3"}
                }, null, 8, ["color"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createVNode(_component_Popover, { trigger: "click" }, {
              content: _withCtx(() => [
                _createVNode(_component_ColorPicker, {
                  modelValue: _unref(background).gradientColor![1],
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = value => updateBackground({ gradientColor: [_unref(background).gradientColor![0], value] }))
                }, null, 8, ["modelValue"])
              ]),
              default: _withCtx(() => [
                _createVNode(ColorButton, {
                  color: _unref(background).gradientColor![1],
                  style: {"flex":"3"}
                }, null, 8, ["color"])
              ]),
              _: 1
            })
          ]),
          (_unref(background).gradientType === 'linear')
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _hoisted_21,
                _createVNode(_component_Slider, {
                  class: "slider",
                  min: 0,
                  max: 360,
                  step: 15,
                  value: _unref(background).gradientRotate,
                  onChange: _cache[7] || (_cache[7] = value => updateBackground({ gradientRotate: value as number }))
                }, null, 8, ["value"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_22, [
      _createVNode(_component_Button, {
        style: {"flex":"1"},
        onClick: _cache[8] || (_cache[8] = ($event: any) => (applyBackgroundAllSlide()))
      }, {
        default: _withCtx(() => [
          _hoisted_23
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_Divider),
    _createElementVNode("div", _hoisted_24, [
      _hoisted_25,
      _createVNode(_component_Select, {
        style: {"flex":"3"},
        value: _unref(viewportRatio),
        onChange: _cache[9] || (_cache[9] = value => updateViewportRatio(value as number))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SelectOption, { value: 0.5625 }, {
            default: _withCtx(() => [
              _hoisted_26
            ]),
            _: 1
          }, 8, ["value"]),
          _createVNode(_component_SelectOption, { value: 0.625 }, {
            default: _withCtx(() => [
              _hoisted_27
            ]),
            _: 1
          }, 8, ["value"]),
          _createVNode(_component_SelectOption, { value: 0.75 }, {
            default: _withCtx(() => [
              _hoisted_28
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _createVNode(_component_Divider),
    _hoisted_29,
    _createElementVNode("div", _hoisted_30, [
      _hoisted_31,
      _createVNode(_component_Select, {
        style: {"flex":"3"},
        value: _unref(theme).fontName,
        onChange: _cache[10] || (_cache[10] = value => updateTheme({ fontName: value as string }))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SelectOptGroup, { label: "系统字体" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableFonts), (font) => {
                return (_openBlock(), _createBlock(_component_SelectOption, {
                  key: font.value,
                  value: font.value
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      style: _normalizeStyle({ fontFamily: font.value })
                    }, _toDisplayString(font.label), 5)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_SelectOptGroup, { label: "在线字体" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(WEB_FONTS), (font) => {
                return (_openBlock(), _createBlock(_component_SelectOption, {
                  key: font.value,
                  value: font.value
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(font.label), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _hoisted_33,
      _createVNode(_component_Popover, { trigger: "click" }, {
        content: _withCtx(() => [
          _createVNode(_component_ColorPicker, {
            modelValue: _unref(theme).fontColor,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = value => updateTheme({ fontColor: value }))
          }, null, 8, ["modelValue"])
        ]),
        default: _withCtx(() => [
          _createVNode(ColorButton, {
            color: _unref(theme).fontColor,
            style: {"flex":"3"}
          }, null, 8, ["color"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_34, [
      _hoisted_35,
      _createVNode(_component_Popover, { trigger: "click" }, {
        content: _withCtx(() => [
          _createVNode(_component_ColorPicker, {
            modelValue: _unref(theme).backgroundColor,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = value => updateTheme({ backgroundColor: value }))
          }, null, 8, ["modelValue"])
        ]),
        default: _withCtx(() => [
          _createVNode(ColorButton, {
            color: _unref(theme).backgroundColor,
            style: {"flex":"3"}
          }, null, 8, ["color"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_36, [
      _hoisted_37,
      _createVNode(_component_Popover, { trigger: "click" }, {
        content: _withCtx(() => [
          _createVNode(_component_ColorPicker, {
            modelValue: _unref(theme).themeColor,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = value => updateTheme({ themeColor: value }))
          }, null, 8, ["modelValue"])
        ]),
        default: _withCtx(() => [
          _createVNode(ColorButton, {
            color: _unref(theme).themeColor,
            style: {"flex":"3"}
          }, null, 8, ["color"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createVNode(_component_Button, {
        style: {"flex":"1"},
        onClick: _cache[14] || (_cache[14] = ($event: any) => (_unref(applyThemeToAllSlides)()))
      }, {
        default: _withCtx(() => [
          _hoisted_39
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_Divider),
    _hoisted_40,
    _createElementVNode("div", _hoisted_41, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PRESET_THEMES), (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "theme-item",
          key: index,
          style: _normalizeStyle({
          backgroundColor: item.background,
          fontFamily: item.fontname,
        })
        }, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", {
              class: "text",
              style: _normalizeStyle({ color: item.fontColor })
            }, "文字 Aa", 4),
            _createElementVNode("div", _hoisted_43, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.colors, (color, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "color-block",
                  key: index,
                  style: _normalizeStyle({ backgroundColor: color})
                }, null, 4))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", {
                class: "btn",
                onClick: ($event: any) => (_unref(applyPresetThemeToSingleSlide)(item))
              }, "应用", 8, _hoisted_45),
              _createElementVNode("div", {
                class: "btn",
                onClick: ($event: any) => (_unref(applyPresetThemeToAllSlides)(item))
              }, "应用全局", 8, _hoisted_46)
            ])
          ])
        ], 4))
      }), 128))
    ])
  ]))
}
}

})